import React from 'react';
import Image from 'next/image';
import { twJoin } from 'tailwind-merge';
import { FileLinkListTile } from './types/FIleLinkListTile';
import Container from '../../shared/Container';
import PdfIcon from '../../../../../public/images/pdf-icon.svg';

export default function FileLinkList({ tile }: { tile: FileLinkListTile }) {
  const title = tile.title?.text;
  const files = tile.files?.files;
  const centerText = tile['center-text']?.value;

  return (
    <Container>
      <div className={twJoin(centerText && 'mx-auto w-fit')}>
        {title && <h2 className={twJoin('md:text-xl', centerText && 'text-center')}>{title}</h2>}
        <ul className={twJoin('ml-2 mt-5 space-y-2 md:text-xl', centerText && 'mx-auto w-fit')}>
          {files?.map((file, index) => (
            <li key={index} className="flex items-center gap-3">
              <div className="h-2 w-2 rounded-full border border-neutral-100" />
              <a
                href={file.url}
                target="_blank"
                className="flex items-center gap-2 underline duration-200 ease-in hover:text-primary-100"
                rel="noopener noreferrer"
              >
                {file.url.endsWith('.pdf') && (
                  <Image src={PdfIcon} alt="pdf icon" width={25} height={25} />
                )}
                {file.title}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </Container>
  );
}
